/**
 * Define constants for mutations here so that there is a central store of what they are
 */
const path = 'widgets/interests/';
export const SET_FEED = `${path}SET_FEED`;
export const SET_LIMIT = `${path}SET_LIMIT`;
export const SET_FILTER = `${path}SET_FILTER`;
export const SET_MAX_QUERY_SIZE = `${path}SET_MAX_QUERY_SIZE`;
export const SET_STATUS = `${path}SET_STATUS`